import { differenceInDays } from 'date-fns'

export const isPasswordTooOld = (lastPasswordUpdate: Date) => {
  const MAX_PASSWORD_TIME_IN_DAYS = 90
  return (
    differenceInDays(new Date(), lastPasswordUpdate) > MAX_PASSWORD_TIME_IN_DAYS
  )
}
